import React, { useState } from "react";
import axios from "axios";
import { baseURL } from "../../../constants/Api";
import BackButton from "../../bars/BackButton";
import CountryCode from "../../../components/Select/CountryCode";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
function Otp({ submitNumber, countryCodeNo }) {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const [validationMsg, setValidationMsg] = useState(false);
  const [loading, setlLoading] = useState(false)
  const [countryMobileCode, setCountryMobileCode] = useState("+91");
  const [value, setValue] = useState('');
 const [emptyPhoneNumber , setEmptyPhoneNumber] = useState(false);
 const [phone, setPhone] = useState('');
 const [isValid, setIsValid] = useState(false);
  // const handleNumber = (e) => {
  //   var numberValue = e.target.value.replace(/\s+/g, '');
  //   console.log(numberValue);
  //   setPhoneNumber(numberValue);
  //   validatePhoneNumber(numberValue);
  //   setValidationMsg(false);
  // };


//  console.log("countryMobileCode===================",countryMobileCode)
  const handlePhoneChange = (e) => {
   let value = e.target.value;
  //  console.log("value===============",value);
    setPhoneNumber(value)
    setEmptyPhoneNumber(false);
    setValidationMsg(false);
    const formattedValue = `${countryMobileCode}${value}`;
    try {
      const phoneNumber = parsePhoneNumberFromString(formattedValue);
      console.log("Parsed Phone Number:", phoneNumber);
 
      if (phoneNumber && phoneNumber.isValid()) {
        setIsValid(true);
        // console.log("The phone number is valid.");
      } else {
        setIsValid(false);
        // console.log("The phone number is not valid.");
      }
    } catch (error) {
      // console.error("Error parsing phone number:", error);
      setIsValid(false);
    }
  };
  // console.log("isValid=======================",isValid)
  const handleOtp = (e) => {
    e.preventDefault();
    if (isValid === false) {
      setValidationMsg(true);
      console.log(phoneNumber)
      setEmptyPhoneNumber(true);
    }
   else if (!phoneError) {
      sentOtp();
      setEmptyPhoneNumber(false);
    } else {
     
      setValidationMsg(true);
    }
  };
 
  const sentOtp = async () => {
    let data = JSON.stringify({
      mobile: phoneNumber,
      country_code:countryMobileCode
    });
 
    let config = {
      method: "post",
      url: `${baseURL}/api/sendloginOtpSMSV21`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: data,
    };
    try {
      setlLoading(true);
      const response = await axios.request(config);
      console.log(response.data);
      submitNumber(phoneNumber);
      countryCodeNo(countryMobileCode);
      if (response.success) {
        setlLoading(false);
      }
 
    } catch (error) {
      setlLoading(false);
      console.log(error);
    };
  };
 
  const validatePhoneNumber = (value) => {
    let isValidPhoneNumber = false;
    if (countryMobileCode === "91") { // India
      isValidPhoneNumber = /^\d{10}$/.test(value);
    } else if (countryMobileCode === "971") { // UAE
      isValidPhoneNumber = /^\d{9}$/.test(value);
    } else if (countryMobileCode === "960") { // Maldives
      isValidPhoneNumber = /^\d{7}$/.test(value);
    } else {
      isValidPhoneNumber = false;  
    }
    setPhoneError(!isValidPhoneNumber);
    setlLoading(false);
  };
 
  return (
    <div className="text-center ">
      <div className="heading flex  flex-col gap-3"style={{marginTop:"0px"}}>
      <BackButton whiteTheme/>
       <div className="mt-5 max-sm:text-left"> Use mobile number to Login / Signup</div></div>
      <div className="mob">Enter mobile number</div>
      <form onSubmit={handleOtp}>
        <div className="mt-4 relative flex justify-center w-full items-center gap-2">
          <div style={{width:"30%"}}>
            <CountryCode handleChange ={(code)=>{setCountryMobileCode(code)}}/>
           </div> 
           <input
          style={{ width: "70%" }}
          className="input"
          value={phoneNumber}
          onChange={handlePhoneChange} // Pass the event handler
          type="text"
        />
          {validationMsg || emptyPhoneNumber ? (
  <span
    className='absolute whitespace-nowrap text-sm text-red-500 left-1/2 -translate-x-1/2 -bottom-6'
  >
    {emptyPhoneNumber ? "Please provide a valid phone number " : "Please enter a valid phone number"}
  </span>
) : null}
 
 
        </div>
        <button
          className={
            !phoneError == "" ? "inactive-button mt-7 flex items-center justify-center mx-auto" : "active-button mt-7 flex justify-center items-center mx-auto"
          }
        >
          Continue and get OTP
 
          {loading ? <div className="loader ml-4"></div> : null}
        </button>
      </form>
    </div>
  );
}
 
export default Otp;